// Api BASE URLs

export const BASE_URL_LIVE = "https://peistaging-api.suffescom.dev";
export const BASE_URL_STAGGING = "https://peistaging-api.suffescom.dev";

export const BASE_URL =
  process.env.REACT_APP_MODE == "live" ? BASE_URL_LIVE : BASE_URL_STAGGING;
export const API_URL =
  process.env.REACT_APP_MODE == "live" ? BASE_URL_LIVE : BASE_URL_STAGGING;
export const API_VERSION = "/api/v1";

// COMMON CONSTANT
export const API_TOKEN = localStorage.getItem("user_id");
export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const PASS_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const Numeric = /^[0-9]+$/;
export const ALPHABET = /^[A-Za-z]+$/;
export const ALPHANUMERIC_REGEX = /[^a-z\d]/i;
export const PASS_VALIDATION_MSG =
  "password should be at least 8 characters, one uppercase, lowercase, special character, numeric value.";

// AUTH URL
export const API_LOGIN = "/admin/adminLogin";

// DASHBOARD
export const DASHBOARD = "/adminDashboard/getDashboardList";

// Stores
export const API_GET_STORES_URL = "/store/";
export const API_GET_STORES_BY_ID = "/store/getstorebyId/";
export const API_ADD_STORES = "/store/register/";
export const API_EDIT_STORES = "/store/updatestore/";
export const API_ADD_STORE_BANKAC = "/store/addaccount/";
export const API_ADD_STORE_DOCS = "/store/addStoreDoc/";
export const API_GET_STORE_DOCS = "/store/getStoreDoc/";

// Store's Categories
export const API_GET_STORES_CATEGORIES = "/storecategory/";
export const API_GET_STORES_CATEGORIE_BY_ID = "/storecategory/edit/";
export const API_ADD_STORES_CATEGORIE = "/storecategory/add/";
export const API_EDIT_STORES_CATEGORIE = "/storecategory/update";
export const API_DELETE_STORES_CATEGORIE = "/storecategory/remove";

// Store's Items
export const API_GET_STORES_ITEMS = "/store/getAllStoreItem/";
export const API_GET_STORES_ITEM_BY_ID = "/store/getItemById/";
export const API_ADD_STORES_ITEM = "/store/addStoreItem/";
export const API_EDIT_STORES_ITEM = "/store/updateStoreItem";
export const API_DELETE_STORES_ITEM = "/store/deleteStoreItem";
export const API_UPDATE_STORE_ITEM_STATUS = "/store/updateItemStatus";

// Cancel Drivers

export const API_GET_CANCELDRIVER_URL = "/adminDashboard/getCancelList";
export const API_RESET_TOTALCANCELATION = "/adminDashboard/resetCount";

// Cancel Customers

export const API_GET_CANCEL_CUSTOMER_URL =
  "/adminDashboard/getCancelCustomerList";

// Drivers

export const API_GET_DRIVER_URL = "/admin/driver/driversList/";

export const API_GET_DRIVER = "/admin/driver/getDriverById/";
export const API_ADD_DRIVER = "/admin/driver/addDriver/";
export const API_EDIT_DRIVER = "/admin/driver/updateDriver/";
export const API_DELETE_DRIVER = "/admin/driver/deleteDriver/";

export const API_DRIVER_PAYMENTS =
  "/admin/driver/getAllDriverTransactionsById/";
export const API_STATUS_CHANGE_RIDER = "/admin/driver/statusChange/";
export const API_BLOCK_RIDER = "/admin/driver/blockUnblock/";

// Customers URLs
export const API_GET_CUSTOMERS_URL = "/admin/getUsersWithFilter/";
export const API_GET_CUSTOMER = "/admin/getUserById/";
export const API_ADD_CUSTOMER = "/admin/addUser/";
export const API_EDIT_CUSTOMER = "/admin/editUser/";
export const API_DELETE_CUSTOMER = "/admin/removeUser/";
export const API_UPLOAD_CUSTOMER = "/user/importCsvList/";
export const API_BLOCK_USER = "/admin/status";

export const API_BLOCK_CUSTOMER_PAYMENT =
  "/adminDashboard/customer/paymentOption";
export const API_UPDATE_CUSTOMER_WALLET_LIMIT =
  "/adminDashboard/update/walletCredit";

// Dispatcher Urls
export const API_ADD_DISPATCHER = "/admin/addDispatcher";
export const API_GET_DISPATCHER = "/admin/getDispatchersById/";
export const API_EDIT_DISPATCHER = "/admin/editDispatcher";
export const API_GET_DISPATCHERS_URL = "/admin/getAllDispatchers/";
export const API_DELETE_DISPATCHER = "/admin/deleteDispatcher";

//Admin Setting URLs
export const API_GET_ALL_ADMINS = "/admin/getAllAdminList/";
export const API_EDIT_ADMIN = "/admin/editAdmin/";
export const API_ADD_ADMIN = "/admin/addAdmin/";
export const API_GET_ADMIN = "/admin/getUserById/";

// Content pages
export const API_GET_CONTENT_PAGES_URL = "/admin/contents/";
export const API_EDIT_CONTENT_PAGE = "/admin/contents/update";
export const API_GET_CONTENT_PAGE_BY_ID = "/admin/contents/edit/";

// Faq
export const API_GET_ALL_FAQ = "/admin/getAllFaqs/";
export const API_ADD_FAQ = "/admin/addFaq/";
export const API_EDIT_FAQ = "/admin/editFaq/";
export const API_GET_FAQ = "/admin/getFaqsById/";
export const API_DELETE_FAQ = "/admin/deleteFaq/";

///// Settings

//Mail Templates Url
export const API_GET_MAIL_TEMPLATES = "/adminSetting/getMailTitle/";
export const API_GET_MAIL_TEMPLATE = "/adminSetting/getMailTemplateById/";
export const API_ADD_MAIL_TEMPLATE = "/adminSetting/addMailTemplate/";
export const API_EDIT_MAIL_TEMPLATE = "/adminSetting/editMailTemplate/";

//Sms Templates Url
export const API_GET_SMS_TEMPLATES = "/adminSetting/getSmsTemplate/";
export const API_GET_SMS_TEMPLATE = "/adminSetting/getSmsTemplateById/";
export const API_ADD_SMS_TEMPLATE = "/adminSetting/addSmsTemplate/";
export const API_EDIT_SMS_TEMPLATE = "/adminSetting/editSmsTemplate/";

// Car Types Urls
export const API_GET_ALL_CAR_TYPES = "/admin/cartypes/";
export const API_GET_CAR_TYPE_BY_ID = "/admin/cartypes/edit/";
export const API_ADD_CAR_TYPE = "/admin/addcartypes/";
export const API_EDIT_CAR_TYPE = "/admin/updatecartype/";
export const API_DELETE_CAR_TYPE = "/admin/removecartypes";

// Trips URLs
export const API_GET_TRIPS = "/adminDashboard/allTripsWithFilter/";
export const API_GET_TRIP_BY_ID = "/adminDashboard/getCompletedDeatailsById/";
export const API_CANCEL_TRIP = "/trip/abortTrip/";

// Promo Code URLs
export const API_GET_ALL_PROMOCODE = "/adminSetting/getPromoCodeList/";
export const API_ADD_PROMOCODE = "/adminSetting/addPromoCode/";
export const API_EDIT_PROMOCODE = "/adminSetting/editPromocode/";
export const API_UPDATE_PROMOCODE_STATUS =
  "/adminSetting/updatePromocodeStatus/";
export const API_GET_PROMOCODE = "/adminSetting/getPromocodeDetails/";
export const API_DELETE_PROMOCODE = "/adminSetting/promocodeDelete/";

// Push Notification URLs
export const SEND_PUSH_NOTIFICATION = "admin/sendNotification";

// Settings
export const API_UPDATE_ADMIN_PASSWORD = "/adminSetting/changePassword/";
export const API_GET_BASIC_SETTINGS = "/adminSetting/getBasicsettinginfo";
export const API_UPDATE_BASIC_SETTINGS = "/adminSetting/basicAppSetting";
export const API_UPDATE_NOTIFICATION_SETTINGS =
  "/adminSetting/notificationSettingUpdate/";
export const API_UPDATE_SOCIAL_SETTINGS = "/adminSetting/basicSocialSetting";
export const API_INSTALLATION_SETTINGS = "/adminSetting/getConfigInfo";
export const API_UPDATE_SMS_INSTALLATION_SETTINGS =
  "/adminSetting/twilioUpdate";
export const API_UPDATE_PAYMENT_INSTALLATION_SETTINGS =
  "/adminSetting/PaymentConfigUpdate";
export const API_UPDATE_MAILGUN_INSTALLATION_SETTINGS =
  "/adminSetting/MailGunConfigUpdate";
export const API_UPDATE_ANDROID_INSTALLATION_SETTINGS =
  "/adminSetting/AndroidAppUrlUpdate";
export const API_UPDATE_IOS_INSTALLATION_SETTINGS =
  "/adminSetting/IOSAppURLUpdate";
export const API_GET_MAILTEMPLATE = "/adminSetting/getMailTitle";
export const API_UPDATE_MAILTEMPLATE = "/adminSetting/editMailTemplate";
export const API_GET_SMSTEMPALTE = "/adminSetting/getSmsTemplate";
export const API_UPDATE_SMSTEMPALTE = "/adminSetting/editSmsTemplate";

//ADITIONAL CHARGES URLs
export const API_GET_CHARGES = "/admin/getItemList";
export const API_ADD_CHARGES = "/admin/addItem";
export const API_CHARGE_BY_ID = "/admin/getItem/";
export const API_EDIT_CHARGES = "/admin/editItem";
export const API_DELETE_CHARGES = "/admin/deleteItem/";

//CONTRACT URLs
export const API_GET_CONTRACT = "/admin/getContractsList";
export const API_ADD_CONTRACT = "/admin/addContract";
export const API_CONTRACT_BY_ID = "/admin/getContract/";
export const API_EDIT_CONTRACT = "/admin/editContract";
export const API_DELETE_CONTRACT = "/admin/deleteContract/";
export const API_GET_CONTRACT_CSV = "/admin/exportContractCsv";

export const API_GET_RESTAURANTS_URL = "/admin/getRestaurantWithFilter";
export const API_GET_RESTAURANTS_All = "/admin/restaurantlist";
export const API_RESTAURANTS_VIEW_URL = "/admin/restaurant/";


export const API_PROMOTIONS_LIST_URL = "/admin/promotions";
export const API_PROMOTIONS_ADD_URL = "/admin/promotions/add";
export const API_PROMOTIONS_GET_URL = "/admin/promotions/view";
export const API_PROMOTIONS_UPDATE_URL = "/admin/promotions/update";
export const API_PROMOTIONS_DELETE_URL = "/admin/promotions/remove";